export const locales = ['uk', 'en'] as const
export const defaultLocale = 'uk' as const

export type Locale = (typeof locales)[number]
